/* This file is autogenerated, see readme.md for instructions */
import ArrowKeyboardUpSvgIcon from '@bloomreach/banana-theme/icons/arrow-keyboard-up.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ArrowKeyboardUpIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ArrowKeyboardUpSvgIcon />
    </Icon>
  );
});

ArrowKeyboardUpIcon.displayName = 'ArrowKeyboardUpIcon';

export default ArrowKeyboardUpIcon;
